module.exports = __webpack_public_path__ + "img/paid.e804e3f0.png";